import { getApiUrl, API_ENDPOINTS } from '../config/api';
import { ApiError } from './errors';

const DEFAULT_OPTIONS = {
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: 'include',
};

const normalizeUser = (user) => {
  if (!user) return null;

  return {
    displayName: user.display_name || user.name || user.username || '',
    email: user.email || '',
    avatar: user.avatar || user.avatar_url || null,
    role: user.role || null,
    permissions: Array.isArray(user.permissions) ? user.permissions : [],
  };
};

export const authService = {
  async getCurrentUser() {
    const response = await fetch(getApiUrl(API_ENDPOINTS.auth.me), {
      ...DEFAULT_OPTIONS,
      method: 'GET',
    });

    if (response.status === 401 || response.status === 403) {
      return null;
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message =
        errorData.detail ||
        errorData.message ||
        errorData.code ||
        `HTTP error! status: ${response.status}`;
      throw new ApiError(message, {
        status: response.status,
        code: errorData.code,
        fieldErrors: errorData.field_errors,
        raw: errorData,
      });
    }

    const payload = await response.json();
    return normalizeUser(payload.user || payload);
  },

  getSignInUrl(provider, { next } = {}) {
    const providerEndpointMap = {
      google: API_ENDPOINTS.auth.googleStart,
    };

    const endpoint = providerEndpointMap[provider];
    if (!endpoint) {
      throw new Error('Unsupported sign-in provider');
    }

    const url = new URL(getApiUrl(endpoint));
    if (next && next.startsWith('/') && !next.startsWith('//')) {
      url.searchParams.set('next', next);
    }
    return url.toString();
  },

  normalizeUser,
};
